























import {
  Component,
  Vue,
  Prop,
  Emit,
} from 'vue-property-decorator';

@Component
export default class ProjectRulesComponent extends Vue {
  @Prop() name!: string;

  @Prop() btnPlus!: boolean;

  @Emit('plus')
  plus() {}
}
